export function readEditableVideoSceneMetadata(cesdk) {
  const pages = cesdk?.engine?.scene?.getPages?.() ?? [];

  if (!pages.length) {
    return null;
  }

  const page = pages[0];
  const { engine } = cesdk;
  const width = Math.round(engine.block.getWidth(page));
  const height = Math.round(engine.block.getHeight(page));
  const durationSeconds = engine.block.getDuration(page);

  if (
    !Number.isFinite(width) ||
    !Number.isFinite(height) ||
    !Number.isFinite(durationSeconds) ||
    width <= 0 ||
    height <= 0 ||
    durationSeconds < 0
  ) {
    return null;
  }

  return {
    width,
    height,
    duration_seconds: durationSeconds,
  };
}

export function formatVideoDuration(durationSeconds) {
  if (!Number.isFinite(durationSeconds) || durationSeconds < 0) {
    return null;
  }

  const totalSeconds = Math.round(durationSeconds);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}

export function formatEditableVideoMetadataLabel(metadata) {
  if (!metadata?.width || !metadata?.height) {
    return null;
  }

  const resolution = `${metadata.width} x ${metadata.height}`;
  const duration = formatVideoDuration(metadata.duration_seconds);

  return duration ? `${resolution} • ${duration}` : resolution;
}

export async function loadEditableVideoScene(cesdk, scene) {
  await cesdk.engine.scene.loadFromString(scene);
  await cesdk.actions.run('zoom.toPage', { page: 'first' });
}
